export default __webpack_public_path__ + "static/media/02.5ee56288.jpg";